@if (isLoaded) {
    <ng-content></ng-content>
}
